/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Favorite.css';
import ReactEcharts from 'echarts-for-react'
import trImg from './triangle.png'
import ciImg from './circle.png'
import { emotionalTendencyPolar, emotionalTendencyBar } from '../../chart';
// import {emotionalTendencyPolar, emotionalTendencyBar} from '../../../chart';


class Favorite extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
    this.getOption = this.getOption.bind(this)
  }

  getOption = () => {

    //   var ss={
    //     "better": {
    //         "mua": 4,
    //         "KOL":7
    //     },
    //     "bad": {
    //         "mua": 17,
    //         "KOL": 8
    //     },
    //     "good": {
    //         "mua": 14,
    //         "KOL": 12
    //     },
    //     "worse": {
    //         "mua": 10,
    //         "KOL": 7
    //     },
    //     "ne": {
    //         "mua": 8,
    //         "KOL": 8
    //     }
    // }
    // console.log(this.props.json)
    let ss=this.props.json

    var likeSum=ss.better.KOL+ss.better.mua+ss.good.KOL+ss.good.mua
    var popSum=ss.bad.KOL+ss.bad.mua+ss.worse.KOL+ss.worse.mua
    var neSum=ss.ne.KOL+ss.ne.mua
    var likeArea=((likeSum/(likeSum+popSum+neSum))*100).toFixed(2)+'%'
    var popArea=((popSum/(likeSum+popSum+neSum))*100).toFixed(2)+'%'
    var neArea=((neSum/(likeSum+popSum+neSum))*100).toFixed(2)+'%'


      


    var data = []
    for (var i = 0; i < 10; i++) {
      data[i] = []
    }

    (function(){
      

    for(var i=0;i<likeSum;i++){
      data[2].push([
        Math.sqrt(Math.random(i)),
        i % 360,
        0,
        0
      ]);
    }

    for(var i=0;i<(ss.better.KOL+ss.good.KOL);i++){
      data[2][i].splice(2,1,1)
    }

    for(var i=0;i<ss.good.KOL;i++){
      data[2][i].splice(3,1,1)
    }
    for(var i=(ss.better.KOL+ss.good.KOL);i<(ss.better.KOL+ss.good.KOL+ss.better.mua);i++){
      data[2][i].splice(3,1,1)
    }


    for (var i = 0; i <popSum ; i++) {
      data[3].push([
        Math.sqrt(Math.random(i)),
        i % 360,
        0,
        0
      ]);
    }
    for(var i=0;i<(ss.bad.KOL+ss.worse.KOL);i++){
        data[3][i].splice(2,1,1)
    }
    for(i=0;i<ss.worse.KOL;i++){
        data[3][i].splice(3,1,1)
    }
    for(var i=(ss.bad.KOL+ss.worse.KOL);i<(ss.bad.KOL+ss.worse.KOL+ss.bad.mua);i++){
        data[3][i].splice(3,1,1)
    }


    for (var i = 0; i <neSum ; i++) {
      data[4].push([
        Math.sqrt(Math.random(i)),
        i % 360,
        0
      ]);
    }
    for(var i=0;i<ss.ne.KOL;i++){
        data[4][i].splice(2,1,1)
    }
    })()



    var polar = [];
    var angleAxis = [];
    var radiusAxis = [];
    var series = [];
    var radius = [likeArea, neArea, popArea]
    for (var i = 0; i < 3; i++) {
      polar.push({
        center: [
          20 + 30 * (i % 3) + '%',
          45 + '%'
        ],
        radius: radius[i]
      });
      angleAxis.push({show: false, polarIndex: i, type: 'value', startAngle: 0});
      radiusAxis.push({
        show: false, polarIndex: i,
        // min: 0,
      });
    }


    let option = {
      title: {
        text: `受众好感图 - ${this.props.items.name}`,
        subtext: '数据来源：数字品牌榜',
        x: '20'

      },
      color:['#f7b2b3','#d1e8f8','#ccc'],
      legend: {
        data: [
          {
              name:'KOL账号',
              icon:`image://${trImg}`,
              
          },{
            name:'普通账号',
            icon:`image://${ciImg}`
          },
          '推荐',
          '好感',
          '中立',
          '差评',
          '反感'
        ],
        
        
      //   backgroundCo:['#fff'],
        bottom: '30',
        right: '30',
        orient: 'vertical',
        selectedMode: false

      },
      tooltip: {
        show: false
      },
      toolbox: {
        feature: {
          restore: {
            show: true
          },
          saveAsImage: {
            show: true
          }
        },
        right: 20
      },
      polar: polar,
      angleAxis: angleAxis,
      radiusAxis: radiusAxis,
      graphic: [
        {
          type: 'text',
          id: 'text1',
          z: 100,
          left: '16%',
          top: '80%',
          style: {
            fill: '#666',
            text: ['顺意群体：' + likeArea],
            font: '16px Microsoft YaHei'
          }
        }, {
          type: 'text',
          id: 'text2',
          z: 100,
          left: '46%',
          top: '80%',
          style: {
            fill: '#666',
            text: ['中立群体：' + neArea],
            font: '16px Microsoft YaHei'
          }
        }, {
          type: 'text',
          id: 'text3',
          z: 100,
          left: '76%',
          top: '80%',
          style: {
            fill: '#666',
            text: ['逆意群体：' + popArea],
            font: '16px Microsoft YaHei'
          }
        }

      ],
      series: [
        {
          coordinateSystem: 'polar',
          name: '推荐',
          type: 'scatter',
          data: data[2].map(function (node) {
              
            // var symbol = []; console.log(node);
            let symbol,
              symbolSize,
              color,
              symbolRotate
            if (node[2] == 1) {
              symbol = 'triangle',
              symbolSize = '12',
              symbolRotate = Math.random() * 360,
              color = '#f7b2b3';
              if(node[3]==1){
                  color='#f9d8d5'
              }
            } else if(node[2]==0){
              symbol = 'circle',
              symbolSize = '10',
              color = '#f9d8d5';
              symbolRotate = 0;
              if (node[3] == 1) {
                symbolSize = '12',
                symbolRotate = Math.random() * 360,
                color = '#f7b2b3'
              }
            }

            return {
              value: [
                node[0], node[1]
              ],
              symbol: symbol,
              symbolSize: symbolSize,
              symbolRotate: symbolRotate,
              itemStyle: {
                normal: {
                  color: color
                }
              }
            }

          })
        }, {
          coordinateSystem: 'polar',
          name: 'KOL账号',
          type: 'scatter',
          zlevel: 300,
          data: data[2][Math.random],
          
          symbol: 'triangle',
          itemStyle: {
            normal: {
              color: '#999',
              borderColor:'red',
              borderWidth:3,
              
            }
          }
        }, {
          coordinateSystem: 'polar',
          name: '好感',
          type: 'scatter',
          data: data[2][Math.random],
          itemStyle: {
            normal: {
              color: '#f9d8d5'
            }
          }
        }, {
          coordinateSystem: 'polar',
          name: '普通账号',
          type: 'scatter',
          symbolSize:0,
          data: [
            0, 0
          ],
          itemStyle: {
            normal: {
              color: '#f9d8d5'
            }
          }
        }, {
          coordinateSystem: 'polar',
          name: '中立',
          type: 'scatter',
          data: data[4].map(function(node){
              
              let symbol,
                  symbolSize,
                  symbolRotate
                  
              if(node[2]==1){
                  symbol='triangle',
                  symbolSize='14',
                  symbolRotate=Math.random()*360
                  
              }else{
                  symbol='circle',
                  symbolSize='10'
                  
              }
              
              return {
                  value:[node[0],node[1]],
                  symbol:symbol,
                  symbolSize:symbolSize,
                  symbolRotate:symbolRotate
              }
          }),
          polarIndex: 1,
          itemStyle: {
            normal: {
              color: '#fee572'
            }
          }
        }, {
          coordinateSystem: 'polar',
          name: '差评',
          type: 'scatter',
          data: data[3].map(function (node) {

            // var symbol = []; console.log(node);
            let symbol,
              symbolSize,
              color,
              symbolRotate

            if (node[2] == 1) {
              symbol = 'triangle',
              symbolSize = '12',
              symbolRotate = Math.random() * 360,
              color = '#d1e8f8';
              if(node[3]==1){
                  color='#9ecef0'
              }
            } else if(node[2]==0){
              symbol = 'circle',
              symbolSize = '10',
              color = '#d1e8f8';
              symbolRotate = 0;
              if (node[3] == 0) {
                symbolSize = '12',
                symbolRotate = Math.random() * 360,
              color = '#9ecef0'
              }
            }

            return {
              value: [
                node[0], node[1]
              ],
              symbol: symbol,
              symbolSize: symbolSize,
              symbolRotate: symbolRotate,
              itemStyle: {
                normal: {
                  color: color
                }
              },
              
            }

          }),

          polarIndex: 2,
          // 	itemStyle: { 		normal: { 			color: '#d1e8f8' 		} 	},
        },  {
          coordinateSystem: 'polar',
          name: '反感',
          type: 'scatter',
          data: data[4][Math.random],
          polarIndex: 2,
          itemStyle: {
            normal: {
              color: '#9ecef0'
            }
          }
        }
      ]
    };
    return option
  }


  render() {
    const {items, json} = this.props;
    const data = {
      chartsJson: json
    };
    const polar = emotionalTendencyPolar(data, {
      brandName: items.name
    });

    return (
      <ReactEcharts
        option={polar}
        style={{
        height: '550px',
        width:'100%',
        
        borderRadius: '4px'
      }}
        className={s.charts}
        notMerge={true}
        lazyUpdate={false}
        theme={"theme_name"}
        onChartReady={this.onChartReadyCallback}/>
    )

  }
}

export default withStyles(s)(Favorite);



// WEBPACK FOOTER //
// src/components/Favorite/Favorite.js